import { renderRichText, storyblokEditable } from "@storyblok/react";
import styleVariables from "@utils/styleVariables";

const styles = styleVariables();

function ClosetPromoBanner({ blok }) {
  if (!blok || !blok.show) return;

  return (
    <div
      key={blok._uid}
      {...storyblokEditable(blok)}
      className={blok.show ? "text-center p-2" : "d-none"}
      style={{ backgroundColor: blok.background_color || styles.tertiary }}
    >
      <div
        dangerouslySetInnerHTML={{ __html: renderRichText(blok.text) }}
        className={`closet-promo-banner-text-container text-2-lines font-size-sm text-${blok.text_color}`}
      />
    </div>
  );
}

export default ClosetPromoBanner;
